export const lessonList = "LESSON_LIST";
export const resetLessonList = "RESET_LESSON_LIST";